module.exports = __webpack_public_path__ + "assets/img/ic-arrow-circle-g.728adeb1.svg";